import React from "react";
import { Col, Row } from "reactstrap";
import { getFieldsReportForm } from "../../../sims/appFormReportsUtility";
function arrayMethod(testSched) {
  let data = [];
  let table = testSched && testSched.formData && testSched.formData.find((field) => field && field.type === "table");
  if (table && table.value) {
    data = getFieldsReportForm(table.value);
  }
  return data;
}

export const rowSection = (tests) => {
  let finalData = [];
  finalData =
   tests && tests.length > 0 &&
    tests.map((testForm, _i) => {
        let test = testForm.summary;

        let data = arrayMethod(testForm);

        return data.length == 0 ? (
          <React.Fragment>
            <div className="label-text">{testForm.title ? testForm.title : "N/A"}</div>
            <div className="value-box">{test.Condition}</div>
            <div className="comments-text info-section">{test.Comments ? test.Comments : " "}</div>
          </React.Fragment>
        ) : null;
      })
      .filter(Boolean);

  return finalData.length > 0 ? (
    <Col md={12} className="border border-dark">
      <Row>
        <Col md={6}></Col>
        <Col md={6}>
          <div className="box-title">Condition</div>
        </Col>
      </Row>
      {finalData}
    </Col>
  ) : (
    []
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/ReportSections/rowSection.jsx